import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"
import "./TeamlidCard.css"

export default function TeamlidCard({ data }) {
  console.log(data)
  const image = getImage(
    data.featuredImage?.node.localFile.childImageSharp.gatsbyImageData
  )
  const li = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3ZM8 18C8.27614 18 8.5 17.7761 8.5 17.5V10.5C8.5 10.2239 8.27614 10 8 10H6.5C6.22386 10 6 10.2239 6 10.5V17.5C6 17.7761 6.22386 18 6.5 18H8ZM7.25 9C6.42157 9 5.75 8.32843 5.75 7.5C5.75 6.67157 6.42157 6 7.25 6C8.07843 6 8.75 6.67157 8.75 7.5C8.75 8.32843 8.07843 9 7.25 9ZM17.5 18C17.7761 18 18 17.7761 18 17.5V12.9C18.0325 11.3108 16.8576 9.95452 15.28 9.76C14.177 9.65925 13.1083 10.1744 12.5 11.1V10.5C12.5 10.2239 12.2761 10 12 10H10.5C10.2239 10 10 10.2239 10 10.5V17.5C10 17.7761 10.2239 18 10.5 18H12C12.2761 18 12.5 17.7761 12.5 17.5V13.75C12.5 12.9216 13.1716 12.25 14 12.25C14.8284 12.25 15.5 12.9216 15.5 13.75V17.5C15.5 17.7761 15.7239 18 16 18H17.5Z"
        fill="black"
      />
    </svg>
  )

  return (
    <div className="vt-teamlid__card">
      <GatsbyImage
        image={image}
        imgStyle={{ objectFit: "contain" }}
        className="vt-teamlid__card--image"
      />
      <div className="vt-teamlid__card--content">
        <h4>{data.title}</h4>
        <h5>{data.teamleden.functietitel}</h5>
        <p dangerouslySetInnerHTML={{ __html: data.teamleden.tekst }}></p>

        <Link to={data.teamleden.linkedinLink}>{li}</Link>
      </div>
    </div>
  )
}
